
<mat-card class="card-web" appearance="outlined">
    <mat-card-header>
      <div class="card-symptom-header-web">
        <div class="card-symptom-icon">
          <app-cold-sinus-flu-icon-web-svg *ngIf="photoUrl == 'Cold-Sinus-Flu-Icon.svg'" style="fill: #8266BC;" ></app-cold-sinus-flu-icon-web-svg>
          <app-pink-eye-icon-web-svg *ngIf="photoUrl == 'Pink-Eye-Icon.svg'" style="fill: #8266BC;"></app-pink-eye-icon-web-svg>
          <app-yeast-infection-icon-web-svg *ngIf="photoUrl == 'Yeast-Infection-Icon.svg'" style="fill: #8266BC;"></app-yeast-infection-icon-web-svg>
          <app-urinary-tract-infection-icon-web-svg *ngIf="photoUrl == 'Urinary-Tract-Infection-Icon.svg'" style="fill: #8266BC;"></app-urinary-tract-infection-icon-web-svg>
          <app-stomach-issues-icon-web-svg *ngIf="photoUrl == 'Stomach-Issues-Icon.svg'" style="fill: #8266BC;"></app-stomach-issues-icon-web-svg>
          <app-skin-condition-icon-web-svg *ngIf="photoUrl == 'Skin-Condition-Icon.svg'" style="fill: #8266BC;"></app-skin-condition-icon-web-svg>
          <app-ear-pain-icon-web-svg *ngIf="photoUrl == 'Ear-Pain-Icon.svg'" style="fill: #8266BC;"></app-ear-pain-icon-web-svg>
        </div>
        <div class="card-provider-wait-time-container-web" *ngIf="waitTime != null && waitTime !=''">
          <div class="card-provider-book-as-soon-as-web">
              {{this.soonAsText}}
          </div>
          <div class="card-provider-availability-web">
              {{waitTime}} {{minutesText}}
          </div>
        </div>
      </div>
    </mat-card-header>
    <mat-card-content class="card-provider-content-mobile">
      <mat-card-title class="card-symptom-title-web">{{title}}</mat-card-title>
    </mat-card-content>
    <mat-card-actions class="card-provider-actions-web">
        <div class="card-provider-detail-bottom-left-web"></div>
        <button mat-button class="action-button-primary" style="width: 117px; height:39px;" (click)="startNow()">{{startNowText}}</button>
    </mat-card-actions>
</mat-card>

